import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import DOMPurify from 'dompurify'; // Untuk proteksi XSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './RegisGathering.css';
import Footer from '../ComponentPrimer/Footer';

const RegisGathering = () => {
  const [qrCodeData, setQrCodeData] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [registrationError, setRegistrationError] = useState('');
  const [registrationStatus, setRegistrationStatus] = useState('');

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [jabatanPosisi, setJabatanPosisi] = useState('');
  const [jenisKelamin, setJenisKelamin] = useState('');
  const [statusPekerjaan, setstatusPekerjaan] = useState('');
  const [fakultas, setfakultas] = useState('');

  const qrCodeRef = useRef();
  const navigate = useNavigate();

  // Fungsi untuk sanitasi input
  const sanitizeInput = (input) => {
    return DOMPurify.sanitize(input);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const whatsappNumber = values.whatsapp.startsWith('08')
      ? `+62${values.whatsapp.slice(1)}`
      : values.whatsapp;

    // const qrCode = `${values.email}${values.whatsapp.slice(-6)}`;
    const qrCode = `${parseInt(values.whatsapp.slice(-6), 10) * 16577}`;

    try {
      const response = await axios.post(
        'https://rlagency.id/app/api_gathering_upi/regis_gathering_upi.php',
        {
          ...values,
          whatsapp: whatsappNumber,
          qrCode,
          jabatanPosisi: sanitizeInput(values.jabatanPosisi),
          bergabungTahun: values.bergabungTahun,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`, // Gunakan token JWT
          },
        }
      );

      if (response.data.status === 'success') {
        setQrCodeData(qrCode);
        setModalOpen(true);
        setFullName(sanitizeInput(values.fullName));
        setEmail(sanitizeInput(values.email));
        setJabatanPosisi(sanitizeInput(values.jabatanPosisi));
        setJenisKelamin(values.jenisKelamin);
        setfakultas(values.fakultas);
        setstatusPekerjaan(values.statusPekerjaan);
      } else {
        setRegistrationStatus(response.data.status);
        setRegistrationError(`${response.data.message}`);
      }
    } catch (error) {
      console.error(error);
      setRegistrationStatus('error');
      setRegistrationError('Terjadi kesalahan saat mendaftar. Silakan coba lagi.');
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().required('Nama Lengkap wajib diisi!'),
    whatsapp: Yup.string()
      .required('Nomor WA wajib diisi!')
      .matches(/^(08|\+62)\d*$/, 'Nomor WA tidak valid') // Hanya angka setelah +62 atau 08
      .min(10, 'Nomor WA tidak valid'),
    email: Yup.string()
      .email('Format email tidak valid')
      .required('Email wajib diisi!'),
    jenisKelamin: Yup.string().required('Jenis Kelamin wajib diisi!'),
    statusPekerjaan: Yup.string().required('Status Pekerjaan wajib diisi!'),
    fakultas: Yup.string().when('statusPekerjaan', {
      is: 'Dosen',
      then: (schema) => schema.required('Fakultas wajib diisi untuk Dosen!'),
      otherwise: (schema) => schema.notRequired(),
    }),
    jabatanPosisi: Yup.string().required('Jabatan/Posisi wajib diisi!'),
  });

  const downloadQRCode = () => {
    html2canvas(qrCodeRef.current).then((canvas) => {
      const link = document.createElement('a');
      const fullNameForFile = fullName.replace(/\s+/g, '_');
      link.href = canvas.toDataURL('image/jpeg');
      link.download = `QR-Gathering-Upi-2025-${fullNameForFile}.jpeg`;
      link.click();
      sendEmail(fullNameForFile);
    });
  };

  const sendEmail = async () => {
    if (!qrCodeRef.current) {
      console.error("QR Code element not found!");
      return;
    }

    html2canvas(qrCodeRef.current).then(async (canvas) => {
      const qrCodeBase64 = canvas.toDataURL('image/png');

      try {
        await axios.post(
          'https://rlagency.id/app/api_gathering_upi/regis_gathering_upi.php',
          {
            email: sanitizeInput(email),
            fullName: sanitizeInput(fullName),
            jabatanPosisi: sanitizeInput(jabatanPosisi),
            jenisKelamin,
            statusPekerjaan,
            fakultas,
            modalContent: qrCodeBase64,
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`, // Gunakan token JWT
            },
          }
        );
        console.log('Email sent successfully!');
      } catch (error) {
        console.error('Error sending email:', error);
      }
    });
  };

  const redirectToCekData = () => {
    navigate('/gathering-repeat-info-search');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <div style={{ backgroundColor: '#171717' }}>
        <img 
          src={`./logo-upi-dan-yayasan.png`} 
          alt="Logo Gathering" 
          style={{ 
              width: '150px', 
              padding:'20px 0px', 
              display: 'block', 
              margin: '0 auto' 
          }} 
        />
      </div>
      <div className="container mt-5" style={{ maxWidth: '600px' }}>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <h2 style={{ fontSize: '26px', textTransform: 'uppercase' }}>Form Gathering UPI-YPTK 2025</h2>
          <Button color="warning" onClick={redirectToCekData} style={{ fontSize: '14px', lineHeight: '16px' }}>
            Download Ulang QR
          </Button>
        </div>
        <hr />
        <Formik
          initialValues={{ 
            fullName: '', 
            whatsapp: '', 
            email: '',
            jenisKelamin: '',
            statusPekerjaan: '',
            fakultas: '',
            jabatanPosisi: '',
        }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="fullName">Nama Lengkap</Label>
                <Input type="text" name="fullName" onChange={handleChange} onBlur={handleBlur} value={values.fullName} />
                {errors.fullName && touched.fullName && <div className="text-danger"><small>{errors.fullName}</small></div>}
              </FormGroup>
              <FormGroup>
                <Label for="whatsapp">No WhatsApp Aktif</Label>
                <Input type="text" name="whatsapp" onChange={handleChange} onBlur={handleBlur} value={values.whatsapp} />
                {errors.whatsapp && touched.whatsapp && <div className="text-danger"><small>{errors.whatsapp}</small></div>}
              </FormGroup>
              <FormGroup>
                <Label for="email">E-mail</Label>
                <Input type="email" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} />
                {errors.email && touched.email && <div className="text-danger"><small>{errors.email}</small></div>}
              </FormGroup>
              <FormGroup>
              <Label for="jenisKelamin">Jenis Kelamin</Label>
              <Input type="select" name="jenisKelamin" onChange={handleChange} onBlur={handleBlur} value={values.jenisKelamin}>
                <option value="">- Pilih - </option>
                <option value="Laki-laki">Laki-laki</option>
                <option value="Perempuan">Perempuan</option>
              </Input>
              {errors.jenisKelamin && touched.jenisKelamin && <div className="text-danger"><small>{errors.jenisKelamin}</small></div>}
            </FormGroup>

            <FormGroup>
              <Label for="statusPekerjaan">Kategori Pekerjaan</Label>
              <Input type="select" name="statusPekerjaan" onChange={(e) => { handleChange(e); setstatusPekerjaan(e.target.value); }} value={values.statusPekerjaan}>
                <option value="">- Pilih -</option>
                <option value="Dosen">Dosen</option>
                <option value="Karyawan">Karyawan</option>
              </Input>
              {errors.statusPekerjaan && touched.statusPekerjaan && <div className="text-danger"><small>{errors.statusPekerjaan}</small></div>}
            </FormGroup>

            {statusPekerjaan === 'Dosen' && (
              <FormGroup>
                <Label for="fakultas">Fakultas</Label>
                <Input type="select" name="fakultas" onChange={handleChange} onBlur={handleBlur} value={values.fakultas}>
                  <option value="">- Pilih Fakultas -</option>
                  <option value="Ilmu Komputer">Ilmu Komputer</option>
                  <option value="Teknik">Teknik</option>
                  <option value="DKV">DKV</option>
                  <option value="Ekonomi dan Bisnis">Ekonomi dan Bisnis</option>
                  <option value="Psikologi">Psikologi</option>
                  <option value="Keguruan dan Ilmu Pendidikan">Keguruan dan Ilmu Pendidikan</option>
                </Input>
                {errors.fakultas && touched.fakultas && <div className="text-danger"><small>{errors.fakultas}</small></div>}
              </FormGroup>
            )}
              <FormGroup>
                <Label for="jabatanPosisi">Jabatan/ Posisi </Label>
                <Input type="text" name="jabatanPosisi" onChange={handleChange} onBlur={handleBlur} value={values.jabatanPosisi} />
                <small className="form-text text-muted">
                    Masukkan jabatan atau posisi Anda dalam pekerjaan.
                </small>
                {errors.jabatanPosisi && touched.jabatanPosisi && <div className="text-danger"><small>{errors.jabatanPosisi}</small></div>}
              </FormGroup>
        
              <Button type="submit" color="primary" disabled={isSubmitting} style={{minWidth:'150px', marginBottom:'50px'}}>
                Daftar
              </Button>
            </Form>
          )}
        </Formik>

        {/* Modal untuk Pendaftaran Gagal */}
        <Modal isOpen={registrationError !== ''} toggle={() => { setRegistrationError(''); setRegistrationStatus(''); }} centered>
          <ModalHeader toggle={() => { setRegistrationError(''); setRegistrationStatus(''); }}>Pendaftaran Gagal</ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
            <div>{registrationError}</div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => { setRegistrationError(''); setRegistrationStatus(''); }}>Tutup</Button>
          </ModalFooter>
        </Modal>

        {/* Modal untuk QR Code */}
        <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} centered>
          <ModalHeader toggle={() => setModalOpen(!modalOpen)}>Pendaftaran Berhasil</ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
            <div ref={qrCodeRef} className="id-card" style={{ backgroundColor: '#fff' }}>
              <img 
                src={`./logo-upi-dan-yayasan.png`} 
                alt="Logo Gathering" 
                style={{ width: '120px', marginBottom: '20px' }} 
              />
              <h5 style={{textAlign:'center'}}>UPI-YPTK, MELANGKAH LEBIH MAJU!</h5>
              <hr style={{ padding: '0px', margin: '10px auto', width: '85%', borderColor: '#1b1b1b' }} />
              <h6 style={{ marginBottom: '0px' }}>{fullName}</h6>
              <div style={{ height: '1px', width: '100%', margin: '10px 0' }} />
              <QRCodeSVG value={qrCodeData} size={256} />
              <small className="mt-3" style={{ textAlign: 'center', fontSize: '11px', padding: '0px 30px 10px 30px' }}>
                *Download/ Screenshoot QR Code agar anda diizinkan memasuki venue/ gedung acara.
              </small>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={downloadQRCode}>Download QR Code</Button>
          </ModalFooter>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default RegisGathering;